module.exports = __webpack_public_path__ + "img/yt.3ef4ad39.png";